import { ReactNode } from "react";
import { cn } from "../../ClassName";

interface Props {
  className?: string;
  children?: ReactNode;
  id?: string;
}

export function H6(props: Props) {
  const defaultStyling = {
    "tw-font-dm-sans": true,
    "tw-uppercase": true,
    "tw-tracking-[0.08em]": true,
    "tw-text-gray-3": !props.className?.includes("tw-text-"),
  };

  return (
    <h6 className={cn(defaultStyling, props.className)} id={props.id}>
      {props.children}
    </h6>
  );
}
